export function careersExpand() {
    const moreDetailsButtons = document.querySelectorAll(".careers__list-item-moredetails");

    moreDetailsButtons.forEach(button => {
        button.addEventListener("click", function () {
            const content = this.closest(".careers__list-item").querySelector(".careers__list-item-content");
            
            if (content.style.maxHeight) {
                // If the content is already expanded, we collapse it
                content.style.maxHeight = null;
                content.style.opacity = 0;
            } else {
                // If the content is collapsed, we expand it
                content.style.maxHeight = content.scrollHeight + "px";
                content.style.opacity = 1;
            }
        });
    });
}